import TB from '@tiger/bridge';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'components/base/Button';
import ResultPage from 'components/ResultPage';
import UI from 'stores/ui';
import { IS_TIGER_SELF } from 'utils/constants';
import { useTrack } from 'utils/track';
import withProgressForm from 'utils/withProgressForm';

const Complete: FC = () => {
    const navigate = useNavigate();
    const { trackEvent } = useTrack();
    const handleClick = () => {
        trackEvent({
            model: '开户-审核中',
            name: '审核中-点击去入金'
        });

        // 非老虎自营，且处于SDK内直接退出
        if (!IS_TIGER_SELF && UI.isTiger) {
            TB.quit();
        } else {
            navigate('/profile/deposit', { replace: true });
        }
    };

    /**
     * 展示去入金按钮, 点击按钮去入金
     */
    return (
        <div>
            <ResultPage
                className="mb-3"
                status="SUCCESS"
                contentOptions={{
                    text: __('Congratulations!')
                }}
                descriptionOptions={{
                    text: __(
                        'Your application has been submitted successfully. You will receive a confirmation email once your account is approved.'
                    )
                }}
                btnOptions={{
                    text: __('Fund My Account')
                }}
                onClick={handleClick}
            />
            {IS_TIGER_SELF &&
            <Button block type="dark" ghost size="lg" onClick={() => navigate('/profile?type=open', { replace: true })}>
                {__('Go to My account')}
            </Button>}
        </div>
    );
};

export default withProgressForm({
    cache: false,
    basePath: 'open',
    showProgressBar: false,
    eventParams: {
        exposureEventParams: {
            model: '开户-审核中',
            name: '审核中-页面曝光'
        }
    }
})(Complete);
